import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "../../../component/atoms/input/mainInput";
import ImgInputLarge from "../../../component/atoms/input/imgInputLarge";
import Checkbox from "../../../component/atoms/input/checkbox";
import BasicBtn from "../../../component/atoms/button/basicBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";

import ImgPreviewLarge from "../../../component/molecules/imgPreviewLarge";
import VuApi from "../../../api/vu.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import FileApi from "../../../api/file.api";
import { fileUrl } from "../../../api/api";
import Modal from "../../../component/templates/Modal";
import RedBtn from "../../../component/atoms/button/redBtn";
import { route } from "../../../router/route";

const KnowledgeVuEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.knowledge_vu)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 메인 카테고리
  const [categoryBoxOpen, setCategoryBoxOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [isNewOpen, setIsNewOpen] = useState(false);

  const categoryList = [
    { title: "제디피트 본캐", value: "FIRST" },
    { title: "제디피트 부캐", value: "SECOND" },
    { title: "제디피트 유튜브", value: "YOUTUBE" },
    { title: "라이팅크루 블로그", value: "BLOG" },
    { title: "라이팅크루 유튜브", value: "YOUTUBE_CREW" },
  ];

  // ---------- 이미지 관련 --------- //
  const [image, setImage] = useState({
    file: "",
    fileUrl: "",
    fileName: "",
  });
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  useEffect(() => {
    getVuInfo();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getVuInfo = async () => {
    try {
      const response = (await VuApi.getById(id)).data.data.content;

      setTitle(response.title);
      setLink(response.link);
      setIsNewOpen(response.newOpen);
      setSelectedCategory(response.vuType);
      setImage({
        ...image,
        imageOriginFileName: response.imageOriginFileName,
        imageServerFileName: response.imageServerFileName,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const inputFile = (e) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = (value) => {
      setImage({
        imageOriginFileName: null,
        imageServerFileName: null,
        file: file,
        fileUrl: value.target.result,
        fileName: file.name,
      });
    };

    e.target.value = "";
  };

  const deleteFile = () => {
    setImage({
      file: null,
      fileUrl: null,
      fileName: null,
      imageOriginFileName: null,
      imageServerFileName: null,
    });
  };

  const editVuFunc = async () => {
    try {
      if (selectedCategory === "") {
        return toast("카테고리를 선택해주세요.");
      }

      if (title === "") {
        return toast("제목을 입력해주세요.");
      }

      if (image.imageServerFileName === null && image.fileUrl === null) {
        return toast("이미지를 등록해주세요.");
      }

      if (link === "") {
        return toast("이미지 연결링크를 입력해주세요.");
      }

      const data = {
        title: title,
        link: link,
        newOpen: isNewOpen,
        vuType: selectedCategory,
      };

      if (image.fileUrl) {
        const pcImageResponse = await FileApi.fileUpload(
          image.file,
          "admin/vu"
        );

        data.imageOriginFileName = pcImageResponse.data.data.originalFileName;
        data.imageServerFileName = pcImageResponse.data.data.serverFileName;
      } else {
        data.imageOriginFileName = image.imageOriginFileName;
        data.imageServerFileName = image.imageServerFileName;
      }

      await VuApi.update(id, data);

      toast(toastMsg.create);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteHandler = async () => {
    try {
      const data = {
        ids: [id],
        allFlag: false,
      };

      await VuApi.delete(data);

      setDeleteModalOpen(false);
      toast(toastMsg.delete);

      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>Vu: 편집 및 추가</TableTitle>
          {/* 카테고리 영역 */}
          <VuInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <VuInputTitle>카테고리</VuInputTitle>

            <SelectBoxValue
              placeholder="카테고리를 선택해주세요"
              selectedValue={selectedCategory}
              isOpen={categoryBoxOpen}
              wrapperHandler={() => {
                setCategoryBoxOpen(!categoryBoxOpen);
              }}
              itemList={categoryList}
              selectedValueSetterFunc={setSelectedCategory}
            />
          </VuInputWrapper>

          {/* 제목 영역 */}
          <VuInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <VuInputTitle>제목</VuInputTitle>
            <MainInput
              type={"text"}
              placeholder={"내용을 입력해 주세요."}
              style={{ width: "572px" }}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </VuInputWrapper>

          {/* 이미지 영역 */}
          <VuInputWrapper
            style={{
              padding: "21px 0px",
              alignItems: "flex-start",
            }}
          >
            <VuInputTitle>이미지</VuInputTitle>
            <div
              style={{
                width: 254,
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {image.fileUrl || image.imageServerFileName ? (
                <ImgPreviewLarge
                  fileUrl={
                    image.fileUrl
                      ? image.fileUrl
                      : `${fileUrl}/${image.imageServerFileName}`
                  }
                  onClick={() => {
                    deleteFile();
                  }}
                />
              ) : (
                <ImgInputLarge
                  id={"file"}
                  accept={"image/*"}
                  onChange={(e) => {
                    inputFile(e);
                  }}
                />
              )}
              <div
                style={{
                  width: "100%",
                  marginTop: 12,
                }}
              >
                <PretendardText
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "22.75px",
                    color: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  최적 size
                </PretendardText>
                <ul
                  style={{
                    listStyle: "disc",
                    listStylePosition: "inside",
                    listColor: "rgba(181, 181, 181, 0.5)",
                  }}
                >
                  <li
                    style={{
                      fontFamily: "Pretendard",
                      fontSize: "14px",
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      color: "rgba(181, 181, 181, 0.5)",
                    }}
                  >
                    270*170
                  </li>
                </ul>
              </div>
            </div>
          </VuInputWrapper>

          {/* 상품 URL 영역 */}
          <VuInputWrapper
            style={{
              padding: "21px 0px",
              alignItems: "flex-start",
            }}
          >
            <VuInputTitle>이미지 연결링크</VuInputTitle>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 12,
              }}
            >
              <MainInput
                type={"text"}
                placeholder={"https://www.example.com"}
                style={{ width: "572px" }}
                value={link}
                onChange={(e) => {
                  setLink(e.target.value);
                }}
              />

              <CheckboxWrapper
                onClick={() => {
                  setIsNewOpen(!isNewOpen);
                }}
              >
                <Checkbox
                  style={{
                    backgroundColor: "transparent",
                  }}
                  checked={isNewOpen}
                  onChange={() => {
                    setIsNewOpen(!isNewOpen);
                  }}
                />
                <CheckboxText>새 창에서 열기</CheckboxText>
              </CheckboxWrapper>
            </div>
          </VuInputWrapper>
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            {isWriteAuthority && (
              <BasicBtn
                onClick={() => {
                  editVuFunc();
                }}
              >
                수정하기
              </BasicBtn>
            )}

            {/* <RedBtn
              style={{
                height: 50.5,
                width: 70,
              }}
              onClick={() => {
                setDeleteModalOpen(true);
              }}
            >
              삭제
            </RedBtn> */}
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}
    </>
  );
};

export default KnowledgeVuEdit;

const VuInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const VuInputTitle = styled(PretendardText).attrs((props) => {})`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;

  cursor: pointer;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
